import { putMyPageUser } from "src/api/v1/mypage/user/put"
import { MyPageUserPutInputModel } from "src/api/v1/mypage/user/PutInputModel"
import { ApiUserData } from "src/models/user/ApiUserData"

export const updateMyUserInfo = async (
  params: Partial<ApiUserData>,
): Promise<void> => {
  const model = new MyPageUserPutInputModel(params)
  await putMyPageUser(model)
}
